<div class="ui-g">

  <div class="ui-g-12">
    <button pButton label="Criar Usuário" icon="pi pi-plus" class="ui-button-success" (click)="criar()"
      *ngIf="hasPermission('CONFIG_USUARIO_CRIAR')"></button>
  </div>

  <div class="ui-g-12 ui-fluid" *ngIf="hasPermission('CONFIG_USUARIO_CONSULTAR')">
    <p-table [value]="usuarios" [paginator]="true" [rows]="10" [responsive]="true" selectionMode="single"
      (onRowSelect)="onRowSelect($event.data)">
      <ng-template pTemplate="header">
        <tr>
          <th>Nome</th>
          <th>Email</th>
          <th style="width: 70px;" *ngIf="hasPermission('CONFIG_USUARIO_RESET')">
            Senha
          </th>
          <th style="width: 70px;" *ngIf="hasPermission('CONFIG_USUARIO_EXCLUIR')">
            Excluir
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-usuario>
        <tr [pSelectableRow]="usuario">
          <td class="col-center">{{ usuario.nome }}</td>
          <td class="col-center">{{ usuario.email }}</td>
          <td class="col-center" *ngIf="hasPermission('CONFIG_USUARIO_RESET')">
            <p-button icon="fa fa-undo-alt" (click)="resetSenha(usuario.id)" title="Resetar Senha"></p-button>
          </td>
          <td class="col-center" *ngIf="hasPermission('CONFIG_USUARIO_EXCLUIR')">
            <p-button icon="pi pi-trash" (click)="excluir(usuario.id)" title="Excluir Usuário"></p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="4">
            Nenhum usuário cadastrado!
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<nav *ngIf="exibir">
  <p-sidebar [(visible)]="exibir" position="left" styleClass="ui-sidebar-md">
    <app-usuario-cadastro [usuario]="usuario"></app-usuario-cadastro>
  </p-sidebar>
</nav>

<p-blockUI [blocked]="blocked">
  <p-progressSpinner class="spinner-center">
  </p-progressSpinner>
</p-blockUI>
